import { styled, Select, Box, Grid } from '@ltvco/refresh-lib/theme';

export const SocialNetworkSelect = styled(Select)(({ theme }) => ({
  height: '100%',
  minWidth: '120px',
  borderRadius: '0 32px 32px 0',
  paddingLeft: '0',

  '&:before, &:after': {
    display: 'none',
  },

  '&:hover': {
    boxShadow: 'none',
  },

  '& .MuiSelect-select': {
    padding: theme.spacing(1, 1.5),
    fontSize: '16px',
    letterSpacing: '0.03125em',
    lineHeight: '1.5em',
    color: theme.palette.text.secondary,
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },

  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
    paddingLeft: '10px',
    border: `1px solid ${theme.palette.text.disabled}`,
    borderRadius: '32px',

    '& .MuiSelect-select': {
      padding: theme.spacing(1.5),
    },
  },
}));

export const UsernameSearchFieldContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${theme.palette.text.disabled}`,
  borderRadius: '32px',
  padding: theme.spacing(0.375, 1),
  backgroundColor: theme.palette.background.paper,
  width: '100%',
  margin: theme.spacing(4, 0),

  '&:focus-within': {
    borderColor: theme.palette.primary.main,
  },

  '&.error': {
    borderColor: theme.palette.error.main,
  },

  [theme.breakpoints.down('sm')]: {
    margin: 0,
  },
}));

export const UsernameSearchDivider = styled(Box)(({ theme }) => ({
  height: '50px',
  width: '1px',
  backgroundColor: theme.palette.divider,
  margin: theme.spacing(0, 1),
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const UsernameFormContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));
